import { render } from "./TabRoles.vue?vue&type=template&id=5948964b"
import script from "./TabRoles.vue?vue&type=script&lang=js"
export * from "./TabRoles.vue?vue&type=script&lang=js"

import "./TabRoles.vue?vue&type=style&index=0&id=5948964b&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__